module.exports = __webpack_public_path__ + "media/images/front/icon_user_del-879236b450c942b46e83312ce488ff01.png";